import { createAsyncThunk } from "@reduxjs/toolkit";
import { getLoggedInUserAPI } from "../../apiConfig/apiCall";

export const getLoggedInUserDetails = createAsyncThunk('getLoggedInUserDetails', async (username) => {
    const response = await getLoggedInUserAPI(username);
    return response.data;
});